(() => {
  const covers = new Set();
  function align(cover) {
    // Use layout coordinates, never transformed rectangles or rounded offsetTop.
    // This also handles the first intro's unequal split and half-pixel overlap.
    const writes = [];
    cover.querySelectorAll('.ak-carousel-image-cover-top, .ak-carousel-image-cover-bottom').forEach(panel => {
      const style = getComputedStyle(panel);
      let top = parseFloat(style.top);
      let left = parseFloat(style.left);
      if (!Number.isFinite(top)) top = cover.clientHeight - parseFloat(style.bottom || 0) - parseFloat(style.height);
      if (!Number.isFinite(left)) left = 0;
      writes.push([panel,`${-left}px`,`${-top}px`]);
    });
    writes.forEach(([panel,x,y]) => {
      if (panel.style.getPropertyValue('--ak-door-hatch-x') !== x) panel.style.setProperty('--ak-door-hatch-x',x);
      if (panel.style.getPropertyValue('--ak-door-hatch-y') !== y) panel.style.setProperty('--ak-door-hatch-y',y);
    });
  }
  const observer = new ResizeObserver(entries => {
    const changed = new Set(entries.map(entry => entry.target.closest('.ak-carousel-image-cover')));
    changed.forEach(cover => { if (cover) align(cover); });
  });
  function init() {
    covers.forEach(cover => {
      if (cover.isConnected) return;
      observer.unobserve(cover);
      cover.querySelectorAll('.ak-carousel-image-cover-top, .ak-carousel-image-cover-bottom').forEach(panel => observer.unobserve(panel));
      covers.delete(cover);
    });
    document.querySelectorAll('.ak-carousel-image-cover').forEach(cover => {
      if (covers.has(cover)) return;
      covers.add(cover);
      align(cover);
      observer.observe(cover);
      cover.querySelectorAll('.ak-carousel-image-cover-top, .ak-carousel-image-cover-bottom').forEach(panel => observer.observe(panel));
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('ak:carousel-covers-added', init);
})();
